module.exports = __webpack_public_path__ + "static/media/BCFX-BUSD.5b29bdb4.svg";